import { useEffect, useRef } from "react";
import PropTypes from "prop-types";

const ClickBoundary = _ref => {
  let {
    children,
    onClickOutside,
    onClickInside
  } = _ref;
  const clickRef = useClickBoundary({
    onClickInside,
    onClickOutside
  });
  return children(clickRef);
};

ClickBoundary.propTypes = {
  /** Called on render with one argument: refHandler */
  children: PropTypes.func.isRequired,

  /** Called when window catches a click whose target is not a descendant of ref */
  onClickOutside: PropTypes.func,

  /** Called when window catches a click whose target is a descendant of ref */
  onClickInside: PropTypes.func
};
export default ClickBoundary;

const noop = () => {};

export const useClickBoundary = function () {
  let {
    onClickInside = noop,
    onClickOutside = noop
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const clickRef = useRef(null);
  useEffect(() => {
    const handleGlobalBodyClick = event => {
      if (clickRef.current) {
        clickRef.current.contains(event.target) ? onClickInside(event) : onClickOutside(event);
      }
    };

    window.document.body.addEventListener("click", handleGlobalBodyClick, {
      capture: true
    });
    return () => window.document.body.removeEventListener("click", handleGlobalBodyClick, {
      capture: true
    });
  }, [onClickInside, onClickOutside]);
  return clickRef;
};